// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-header-ios {
  padding: 0;
  margin: 0 auto;
}

.list-header-md {
  padding: 0;
}

.lateral-color-section {
  width: 5px;
  height: 55px;
  background: grey;
  opacity: 0.4;
  float: left;
}

.lateral-color-card-ok,
.lateral-color-card-warn {
  width: 5px;
  height: 55px;
  float: left;
}

.lateral-color-card-warn {
  background: #CEA244;
}

.lateral-color-card-ok {
  background: #72B746;
}

.card-content {
  margin: 0 auto;
  width: 100%;
}

.bg-content {
  background: #eeeeee;
}
.bg-content .icon-survey-size {
  font-size: 30px;
  margin-right: 5px;
  position: relative;
  top: 5px;
}

ion-item-divider {
  padding: 0;
  margin: 0;
}

ion-toolbar {
  border-radius: 0;
}
ion-toolbar p {
  font-family: var(--font);
  font-weight: 700;
  font-size: 20px;
}

@media screen and (min-width: 768px) {
  ion-toolbar ion-title p {
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/surveys-list-page/surveys-list-page.page.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,cAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAGA;;EAEI,UAAA;EACA,YAAA;EACA,WAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,cAAA;EACA,WAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;AAEI;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAAR;;AAIA;EACI,UAAA;EACA,SAAA;AADJ;;AAGA;EACI,gBAAA;AAAJ;AACI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAER;;AACA;EAGQ;IACI,gBAAA;EAAV;AACF","sourcesContent":[".list-header-ios {\n    padding: 0;\n    margin: 0 auto;\n}\n\n.list-header-md {\n    padding: 0;\n}\n\n.lateral-color-section {\n    width: 5px;\n    height: 55px;\n    background: grey;\n    opacity: 0.4;\n    float: left;\n}\n\n\n.lateral-color-card-ok,\n.lateral-color-card-warn {\n    width: 5px;\n    height: 55px;\n    float: left;\n}\n\n.lateral-color-card-warn {\n    background: #CEA244;\n}\n\n.lateral-color-card-ok {\n    background: #72B746;\n}\n\n.card-content {\n    margin: 0 auto;\n    width: 100%;\n}\n\n.bg-content {\n    background: #eeeeee;\n\n    .icon-survey-size {\n        font-size: 30px;\n        margin-right: 5px;\n        position: relative;\n        top: 5px;\n    }\n}\n\nion-item-divider {\n    padding: 0;\n    margin: 0;\n}\nion-toolbar{\n    border-radius: 0;\n    p{\n        font-family: var(--font); font-weight: 700;;\n        font-size: 20px;\n    }\n}\n@media screen and (min-width: 768px) {\n    ion-toolbar{\n        // border-radius: 37px;\n        ion-title p{\n            text-align: left;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
